module.exports = __webpack_public_path__ + "assets/assessment-inactive.2fecab8c.svg";